import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export function useHasSpeakers() {
    const [hasSpeakers, setHasSpeakers] = useState(true); // default true to avoid flicker

    useEffect(() => {
        const checkSpeakers = async () => {
            try {
                const { count, error } = await supabase
                    .from('speakers')
                    .select('*', { count: 'exact', head: true });
                
                if (!error) {
                    setHasSpeakers(count > 0);
                }
            } catch (err) {
                console.error(err);
            }
        };
        
        checkSpeakers();
    }, []);

    return hasSpeakers;
}
